import { useEffect, useState } from "react";

export interface SavedView {
  id: string;
  name: string;
  href: string;
  position: number;
}

const KEY = "todo-saved-views";
const EVENT = "todo-saved-views-change";

export function readSavedViews(): SavedView[] {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) ?? "[]") as SavedView[];
    return Array.isArray(value) ? value.sort((a, b) => a.position - b.position) : [];
  } catch {
    return [];
  }
}

export function writeSavedViews(views: SavedView[]) {
  localStorage.setItem(KEY, JSON.stringify(views));
  window.dispatchEvent(new Event(EVENT));
}

export function addSavedView(name: string, href: string) {
  const current = readSavedViews();
  const view = { id: crypto.randomUUID(), name, href, position: (current.length + 1) * 1000 };
  writeSavedViews([...current, view]);
  return view;
}

export function useSavedViews() {
  const [views, setViews] = useState(readSavedViews);
  useEffect(() => { const refresh = () => setViews(readSavedViews()); window.addEventListener(EVENT, refresh); window.addEventListener("storage", refresh); return () => { window.removeEventListener(EVENT, refresh); window.removeEventListener("storage", refresh); }; }, []);
  return views;
}
